<div class="modal-dialog">
  <div class="modal-header">
    <div class="title">
      <span class="kbody-huge" style="font-weight: 700;">Edit Avatar</span>
      <mat-icon
        fontSet="material-icons-round"
        class="close"
        (click)="closeModal()"
      >
        close
      </mat-icon>
    </div>
  </div>

  <div class="container">
    <div class="avatar">
      <app-avatar
        size="xl"
        [loginName]="(user$ | async)?.loginName"
        [userId]="(user$ | async)?.id"
      ></app-avatar>
    </div>

    <div style="width: 600px;">
      <app-upload-file
        [entityId]="(user$ | async).Entity.id"
        [noUploadDropzone]="false"
        [fileTypeInS3]="fileTypeInS3"
      >
        <span
          overrideFooter
          class="kbody-small"
        >
          JPG or PNG (max 10mb)
        </span>
      </app-upload-file>

      <div class="actions">
        <div>
          <app-new-button
            color="red"
            size="default"
            (clickHandler)="removeImage()"
          >
            Remove Image
          </app-new-button>
        </div>

        <div style="display: flex; gap: 10px;">
          <app-new-button
            color="ghost"
            size="default"
            (clickHandler)="closeModal()"
          >
            Cancel
          </app-new-button>

          <app-new-button
            color="blue"
            size="default"
            (clickHandler)="saveAvatar()"
          >
            Save Changes
          </app-new-button>
        </div>
      </div>
    </div>
  </div>
</div>